import React, { useState } from "react";
import "../../Styles/AdminSetting.css";

const AdminSettingsPage = () => {
  const [profileData, setProfileData] = useState({
    name: "Ramesh Kumar",
    role: "Administrator",
    email: "admin@mlaconnect.gov.in",
    mobile: "9876541230",
    department: "Administration",
    office: "MLA Office, Kandukur",
  });

  const [notifications, setNotifications] = useState({
    newBeneficiary: true,
    followUpReminders: true,
    eventReminders: true,
    smsAlerts: false,
    emailReports: true,
  });

  const [twoFactorEnabled, setTwoFactorEnabled] = useState(true);

  const [staffData, setStaffData] = useState([
    { id: 1, name: "Ramesh Kumar", role: "Admin", mobile: "9876500001", status: "Active", initials: "RK", color: "setting1234-avatar-blue" },
    { id: 2, name: "Priya Sharma", role: "Data Entry", mobile: "9876500002", status: "Active", initials: "PS", color: "setting1234-avatar-pink" },
    { id: 3, name: "Suresh Babu", role: "Field Coordinator", mobile: "9876500003", status: "Inactive", initials: "SB", color: "setting1234-avatar-orange" },
  ]);

  const [staffSearch, setStaffSearch] = useState("");
  const [staffPage, setStaffPage] = useState(1);

  const [constituencyInfo, setConstituencyInfo] = useState({
    name: "Kandukur",
    district: "SPSR Nellore",
    mandals: "3",
    villages: "52",
    population: "2,85,462",
  });

  // ---------- Staff Modal (Add / Edit) ----------
  const [isStaffModalOpen, setIsStaffModalOpen] = useState(false);
  const [staffModalMode, setStaffModalMode] = useState("add");
  const [staffForm, setStaffForm] = useState({
    id: null,
    name: "",
    role: "",
    mobile: "",
    status: "Active",
  });

  // ---------- Delete Staff Confirm ----------
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  // ---------- Change Password Modal ----------
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    current: "",
    newPass: "",
    confirm: "",
  });

  // ---------- Edit Constituency Modal ----------
  const [showConstModal, setShowConstModal] = useState(false);
  const [constForm, setConstForm] = useState({ ...constituencyInfo });

  const handleProfileChange = (e) => {
    setProfileData({ ...profileData, [e.target.name]: e.target.value });
  };

  const toggleNotification = (key) => {
    setNotifications({ ...notifications, [key]: !notifications[key] });
  };

  // ---------- Staff logic ----------
  const initialsOf = (name) =>
    name
      .split(" ")
      .map((w) => w[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);

  const avatarColors = ["setting1234-avatar-blue", "setting1234-avatar-pink", "setting1234-avatar-orange", "setting1234-avatar-green", "setting1234-avatar-purple"];

  const openAddStaffModal = () => {
    setStaffModalMode("add");
    setStaffForm({ id: null, name: "", role: "", mobile: "", status: "Active" });
    setIsStaffModalOpen(true);
  };

  const openEditStaffModal = (staff) => {
    setStaffModalMode("edit");
    setStaffForm({ ...staff });
    setIsStaffModalOpen(true);
  };

  const closeStaffModal = () => {
    setIsStaffModalOpen(false);
  };

  const handleStaffFormChange = (e) => {
    const { name, value } = e.target;
    setStaffForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleStaffSubmit = (e) => {
    e.preventDefault();

    if (!staffForm.name || !staffForm.role || !staffForm.mobile) {
      alert("Please fill all required fields");
      return;
    }

    if (staffModalMode === "add") {
      const newEntry = {
        id: staffData.length > 0 ? Math.max(...staffData.map((s) => s.id)) + 1 : 1,
        name: staffForm.name,
        role: staffForm.role,
        mobile: staffForm.mobile,
        status: staffForm.status,
        initials: initialsOf(staffForm.name),
        color: avatarColors[staffData.length % avatarColors.length],
      };
      setStaffData((prev) => [...prev, newEntry]);
    } else {
      setStaffData((prev) =>
        prev.map((s) =>
          s.id === staffForm.id
            ? { ...s, ...staffForm, initials: initialsOf(staffForm.name) }
            : s
        )
      );
    }

    setIsStaffModalOpen(false);
  };

  const openDeleteModal = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setDeleteId(null);
  };

  const confirmDeleteStaff = () => {
    setStaffData((prev) => prev.filter((s) => s.id !== deleteId));
    closeDeleteModal();
  };

  // ---------- Staff search filter ----------
  const filteredStaff = staffData.filter((s) => {
    const q = staffSearch.trim().toLowerCase();
    if (q === "") return true;
    return (
      s.name.toLowerCase().includes(q) ||
      s.role.toLowerCase().includes(q) ||
      s.mobile.includes(q) ||
      s.status.toLowerCase().includes(q)
    );
  });

  // ---------- Password logic ----------
  const openPasswordModal = () => {
    setPasswordForm({ current: "", newPass: "", confirm: "" });
    setShowPasswordModal(true);
  };

  const closePasswordModal = () => {
    setShowPasswordModal(false);
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordForm((prev) => ({ ...prev, [name]: value }));
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();

    if (!passwordForm.current || !passwordForm.newPass || !passwordForm.confirm) {
      alert("Please fill all password fields");
      return;
    }

    if (passwordForm.newPass !== passwordForm.confirm) {
      alert("New password and confirm password do not match");
      return;
    }

    alert("Password updated successfully");
    closePasswordModal();
  };

  // ---------- Constituency Info logic ----------
  const openConstModal = () => {
    setConstForm({ ...constituencyInfo });
    setShowConstModal(true);
  };

  const closeConstModal = () => {
    setShowConstModal(false);
  };

  const handleConstFormChange = (e) => {
    const { name, value } = e.target;
    setConstForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleConstSubmit = (e) => {
    e.preventDefault();
    setConstituencyInfo({ ...constForm });
    setShowConstModal(false);
  };

  return (
    <div className="setting1234-page">
      {/* Header */}
      <div className="setting1234-header">
        <h2 className="setting1234-title">Settings</h2>
        <p className="setting1234-subtitle">
          Manage your profile, account, team and preferences
        </p>
      </div>

      {/* Row 1: Profile Information + Constituency Information */}
      <div className="setting1234-top-row-grid">
        {/* Profile Card */}
        <div className="setting1234-card setting1234-profile-card">
          <div className="setting1234-card-title-row">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.7" />
              <path d="M4 20c0-3.5 3.6-6 8-6s8 2.5 8 6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
            </svg>
            <h3>Profile Information</h3>

            <button className="setting1234-change-photo-btn">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                <path d="M4 8a2 2 0 012-2h1l1.5-2h7L17 6h1a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V8z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
                <circle cx="12" cy="13" r="3.5" stroke="currentColor" strokeWidth="1.7" />
              </svg>
              Change Photo
            </button>
          </div>

          <div className="setting1234-profile-body">
            <div className="setting1234-profile-photo-col">
              <div className="setting1234-profile-photo">
                {initialsOf(profileData.name)}
              </div>
              <span className="setting1234-profile-name">{profileData.name}</span>
              <span className="setting1234-profile-tag">{profileData.role}</span>
            </div>

            <div className="setting1234-profile-form-col">
              <div className="setting1234-form-grid">
                <div className="setting1234-form-group">
                  <label>Full Name</label>
                  <div className="setting1234-input-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.7" />
                      <path d="M4 20c0-3.3 3.4-5.5 8-5.5s8 2.2 8 5.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
                    </svg>
                    <input
                      type="text"
                      name="name"
                      value={profileData.name}
                      onChange={handleProfileChange}
                    />
                  </div>
                </div>

                <div className="setting1234-form-group">
                  <label>Email Address</label>
                  <div className="setting1234-input-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.6" />
                      <path d="M3 7l9 6 9-6" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
                    </svg>
                    <input
                      type="email"
                      name="email"
                      value={profileData.email}
                      onChange={handleProfileChange}
                    />
                  </div>
                </div>

                <div className="setting1234-form-group">
                  <label>Mobile Number</label>
                  <div className="setting1234-input-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path d="M22 16.9v3a2 2 0 01-2.2 2 19.8 19.8 0 01-8.6-3.1 19.5 19.5 0 01-6-6A19.8 19.8 0 012.1 4.2 2 2 0 014.1 2h3a2 2 0 012 1.7c.1.9.3 1.8.6 2.7a2 2 0 01-.5 2.1L8 9.7a16 16 0 006 6l1.2-1.2a2 2 0 012.1-.5c.9.3 1.8.5 2.7.6a2 2 0 011.7 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
                    </svg>
                    <input
                      type="tel"
                      name="mobile"
                      value={profileData.mobile}
                      onChange={handleProfileChange}
                    />
                  </div>
                </div>

                <div className="setting1234-form-group">
                  <label>Department</label>
                  <select
                    name="department"
                    value={profileData.department}
                    onChange={handleProfileChange}
                  >
                    <option value="Administration">Administration</option>
                    <option value="Field Operations">Field Operations</option>
                    <option value="Public Relations">Public Relations</option>
                    <option value="Grievance Cell">Grievance Cell</option>
                  </select>
                </div>

                <div className="setting1234-form-group setting1234-full-width">
                  <label>Office Location</label>
                  <div className="setting1234-input-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 22s7-6.5 7-12a7 7 0 10-14 0c0 5.5 7 12 7 12z"
                        stroke="currentColor"
                        strokeWidth="1.6"
                        strokeLinejoin="round"
                      />
                      <circle cx="12" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.6" />
                    </svg>
                    <input
                      type="text"
                      name="office"
                      value={profileData.office}
                      onChange={handleProfileChange}
                    />
                  </div>
                </div>
              </div>

              <button className="setting1234-save-btn">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path d="M5 13l4 4L19 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Save Changes
              </button>
            </div>
          </div>
        </div>

        {/* Constituency Info */}
        <div className="setting1234-card setting1234-constituency-card">
          <div className="setting1234-constituency-row">
            <div className="setting1234-card-title-row">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
                <path d="M4 21V9l8-6 8 6v12M9 21v-6h6v6" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
              </svg>
              <h3>Constituency Information</h3>
            </div>

            <button className="setting1234-edit-info-btn" onClick={openConstModal}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 20h9M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4 12.5-12.5z"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Edit
            </button>
          </div>

          <div className="setting1234-const-list">
            <div className="setting1234-const-list-item">
              <div className="setting1234-const-icon setting1234-const-icon-blue">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path d="M4 21V9l8-6 8 6v12M9 21v-6h6v6" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
                </svg>
              </div>
              <span className="setting1234-const-list-label">Constituency</span>
              <span className="setting1234-const-list-value">{constituencyInfo.name}</span>
            </div>

            <div className="setting1234-const-list-item">
              <div className="setting1234-const-icon setting1234-const-icon-purple">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.6" />
                  <path d="M3 9h18M9 4v16" stroke="currentColor" strokeWidth="1.6" />
                </svg>
              </div>
              <span className="setting1234-const-list-label">District</span>
              <span className="setting1234-const-list-value">{constituencyInfo.district}</span>
            </div>

            <div className="setting1234-const-list-item">
              <div className="setting1234-const-icon setting1234-const-icon-green">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <circle cx="9" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.6" />
                  <path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                </svg>
              </div>
              <span className="setting1234-const-list-label">Mandal(s)</span>
              <span className="setting1234-const-list-value">{constituencyInfo.mandals}</span>
            </div>

            <div className="setting1234-const-list-item">
              <div className="setting1234-const-icon setting1234-const-icon-orange">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path d="M3 21h18M5 21V7l7-4 7 4v14M9 9h1M9 13h1M14 9h1M14 13h1" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <span className="setting1234-const-list-label">Village(s)</span>
              <span className="setting1234-const-list-value">{constituencyInfo.villages}</span>
            </div>

            <div className="setting1234-const-list-item">
              <div className="setting1234-const-icon setting1234-const-icon-red">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <circle cx="9" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.6" />
                  <path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                  <circle cx="17" cy="8" r="2.6" stroke="currentColor" strokeWidth="1.6" />
                  <path d="M15.5 14.7c2.6.4 4.5 2.3 4.5 5.3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                </svg>
              </div>
              <span className="setting1234-const-list-label">Population</span>
              <span className="setting1234-const-list-value">{constituencyInfo.population}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Row 2: Security | Staff | Notifications */}
      <div className="setting1234-bottom-row-grid">
        {/* Account & Security */}
        <div className="setting1234-card setting1234-security-card">
          <div className="setting1234-card-title-row">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
              <path d="M12 2l8 4v6c0 5-3.4 8.7-8 10-4.6-1.3-8-5-8-10V6l8-4z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
            </svg>
            <h3>Security Settings</h3>
          </div>

          <button className="setting1234-security-item" onClick={openPasswordModal}>
            <div className="setting1234-security-icon setting1234-sec-icon-green">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                <rect x="5" y="11" width="14" height="9" rx="2" stroke="currentColor" strokeWidth="1.7" />
                <path d="M8 11V8a4 4 0 018 0v3" stroke="currentColor" strokeWidth="1.7" />
              </svg>
            </div>
            <div className="setting1234-security-text">
              <span className="setting1234-security-label">Change Password</span>
              <span className="setting1234-security-desc">Update your account password regularly</span>
            </div>
            <svg className="setting1234-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>

          <div className="setting1234-security-item setting1234-security-item-static">
            <div className="setting1234-security-icon setting1234-sec-icon-orange">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="4" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.7" />
                <path d="M8 21h8M12 18v3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
              </svg>
            </div>
            <div className="setting1234-security-text">
              <span className="setting1234-security-label">Two Factor Authentication</span>
              <span className="setting1234-security-desc">Add an extra layer of security</span>
            </div>
            {twoFactorEnabled ? (
              <span
                className="setting1234-2fa-badge"
                onClick={() => setTwoFactorEnabled(false)}
              >
                Enabled
              </span>
            ) : (
              <span
                className="setting1234-2fa-badge setting1234-2fa-badge-off"
                onClick={() => setTwoFactorEnabled(true)}
              >
                Disabled
              </span>
            )}
          </div>

          <div className="setting1234-security-item setting1234-security-item-static">
            <div className="setting1234-security-icon setting1234-sec-icon-blue">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                <rect x="2" y="5" width="16" height="12" rx="2" stroke="currentColor" strokeWidth="1.7" />
                <path d="M22 8l-4 3 4 3V8z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
              </svg>
            </div>
            <div className="setting1234-security-text">
              <span className="setting1234-security-label">Active Sessions</span>
              <span className="setting1234-security-desc">Manage your active login sessions</span>
            </div>
            <svg className="setting1234-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>

          <div className="setting1234-security-item setting1234-security-item-static">
            <div className="setting1234-security-icon setting1234-sec-icon-red">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.7" />
                <path d="M12 7v5l3.5 2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <div className="setting1234-security-text">
              <span className="setting1234-security-label">Login Activity</span>
              <span className="setting1234-security-desc">View your recent login history</span>
            </div>
            <svg className="setting1234-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>

          <div className="setting1234-secure-note">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
              <path d="M8.5 12.5l2.5 2.5 4.5-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <div>
              <strong>Your account is secure</strong>
              <p>All security settings are up to date and your account is protected.</p>
            </div>
          </div>
        </div>

        {/* Staff Management */}
        <div className="setting1234-card setting1234-staff-card">
          <div className="setting1234-card-header-row">
            <div className="setting1234-card-title-row">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
                <circle cx="9" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.7" />
                <path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
                <circle cx="17" cy="8" r="2.6" stroke="currentColor" strokeWidth="1.7" />
                <path d="M15.5 14.7c2.6.4 4.5 2.3 4.5 5.3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
              </svg>
              <h3>Staff Management</h3>
            </div>

            <button className="setting1234-add-staff-btn" onClick={openAddStaffModal}>
              + Add Staff
            </button>
          </div>

          <div className="setting1234-staff-search-box">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
              <path d="M21 21l-4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
            <input
              type="text"
              placeholder="Search staff by name, role, mobile..."
              value={staffSearch}
              onChange={(e) => setStaffSearch(e.target.value)}
            />
          </div>

          <div className="setting1234-staff-table-wrapper">
            <table className="setting1234-staff-table">
              <thead>
                <tr>
                  <th>Staff Member</th>
                  <th>Role</th>
                  <th>Mobile</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredStaff.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="setting1234-staff-empty">
                      No staff members found.
                    </td>
                  </tr>
                ) : (
                  filteredStaff.map((staff) => (
                    <tr key={staff.id}>
                      <td>
                        <div className="setting1234-staff-name-cell">
                          <div className={`setting1234-avatar ${staff.color}`}>
                            {staff.initials}
                          </div>
                          {staff.name}
                        </div>
                      </td>
                      <td>
                        <span className="setting1234-role-badge">{staff.role}</span>
                      </td>
                      <td>{staff.mobile}</td>
                      <td>
                        <span
                          className={`setting1234-staff-status ${
                            staff.status === "Active"
                              ? "setting1234-staff-active"
                              : "setting1234-staff-inactive"
                          }`}
                        >
                          {staff.status}
                        </span>
                      </td>
                      <td className="setting1234-staff-action-cell">
                        <button
                          className="setting1234-edit-btn"
                          onClick={() => openEditStaffModal(staff)}
                        >
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                            <path
                              d="M12 20h9M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4 12.5-12.5z"
                              stroke="currentColor"
                              strokeWidth="1.9"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                        <button
                          className="setting1234-delete-btn"
                          onClick={() => openDeleteModal(staff.id)}
                        >
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                            <path
                              d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0l-1 14a2 2 0 01-2 2H7a2 2 0 01-2-2L4 6h16z"
                              stroke="currentColor"
                              strokeWidth="1.9"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <div className="setting1234-staff-footer">
            <span className="setting1234-staff-total">
              Total Staff: {filteredStaff.length}
            </span>

            <div className="setting1234-staff-pagination">
              <button
                className="setting1234-page-arrow"
                onClick={() => setStaffPage((p) => Math.max(1, p - 1))}
              >
                &lt;
              </button>
              <button className="setting1234-page-num setting1234-active">
                {staffPage}
              </button>
              <button
                className="setting1234-page-arrow"
                onClick={() => setStaffPage((p) => p + 1)}
              >
                &gt;
              </button>
            </div>
          </div>
        </div>

        {/* Notification Preferences */}
        <div className="setting1234-card setting1234-notif-card">
          <div className="setting1234-card-title-row">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
              <path d="M6 8a6 6 0 1112 0c0 5 2 6 2 6H4s2-1 2-6z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
              <path d="M9.5 20a2.5 2.5 0 005 0" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
            </svg>
            <h3>Notification Preferences</h3>
          </div>

          <div className="setting1234-notif-list">
            <div className="setting1234-notif-item">
              <div className="setting1234-notif-icon setting1234-notif-icon-blue">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <circle cx="9" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.7" />
                  <path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
                </svg>
              </div>
              <div className="setting1234-notif-text">
                <span className="setting1234-notif-label">New Beneficiary Alerts</span>
                <span className="setting1234-notif-desc">Get notified when new beneficiary is added</span>
              </div>
              <label className="setting1234-switch">
                <input
                  type="checkbox"
                  checked={notifications.newBeneficiary}
                  onChange={() => toggleNotification("newBeneficiary")}
                />
                <span className="setting1234-slider"></span>
              </label>
            </div>

            <div className="setting1234-notif-item">
              <div className="setting1234-notif-icon setting1234-notif-icon-green">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.7" />
                  <path d="M12 7v5l3.5 2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div className="setting1234-notif-text">
                <span className="setting1234-notif-label">Follow Up Reminders</span>
                <span className="setting1234-notif-desc">Receive follow up reminders</span>
              </div>
              <label className="setting1234-switch">
                <input
                  type="checkbox"
                  checked={notifications.followUpReminders}
                  onChange={() => toggleNotification("followUpReminders")}
                />
                <span className="setting1234-slider"></span>
              </label>
            </div>

            <div className="setting1234-notif-item">
              <div className="setting1234-notif-icon setting1234-notif-icon-purple">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.7" />
                  <path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
                </svg>
              </div>
              <div className="setting1234-notif-text">
                <span className="setting1234-notif-label">Event Reminders</span>
                <span className="setting1234-notif-desc">Get notified about upcoming events</span>
              </div>
              <label className="setting1234-switch">
                <input
                  type="checkbox"
                  checked={notifications.eventReminders}
                  onChange={() => toggleNotification("eventReminders")}
                />
                <span className="setting1234-slider"></span>
              </label>
            </div>

            <div className="setting1234-notif-item">
              <div className="setting1234-notif-icon setting1234-notif-icon-gray">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="1.7" />
                  <path d="M2 7l10 6 10-6" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
                </svg>
              </div>
              <div className="setting1234-notif-text">
                <span className="setting1234-notif-label">SMS Alerts</span>
                <span className="setting1234-notif-desc">Receive important SMS alerts</span>
              </div>
              <label className="setting1234-switch">
                <input
                  type="checkbox"
                  checked={notifications.smsAlerts}
                  onChange={() => toggleNotification("smsAlerts")}
                />
                <span className="setting1234-slider"></span>
              </label>
            </div>

            <div className="setting1234-notif-item">
              <div className="setting1234-notif-icon setting1234-notif-icon-blue">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.6" />
                  <path d="M3 7l9 6 9-6" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
                </svg>
              </div>
              <div className="setting1234-notif-text">
                <span className="setting1234-notif-label">Email Reports</span>
                <span className="setting1234-notif-desc">Receive email reports</span>
              </div>
              <label className="setting1234-switch">
                <input
                  type="checkbox"
                  checked={notifications.emailReports}
                  onChange={() => toggleNotification("emailReports")}
                />
                <span className="setting1234-slider"></span>
              </label>
            </div>
          </div>

          <button className="setting1234-save-preferences-btn">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M5 13l4 4L19 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Save Preferences
          </button>
        </div>
      </div>

      {/* ---------------- ADD / EDIT STAFF MODAL ---------------- */}
      {isStaffModalOpen && (
        <div className="setting1234-modal-overlay" onClick={closeStaffModal}>
          <div className="setting1234-modal-box" onClick={(e) => e.stopPropagation()}>
            <div className="setting1234-modal-header">
              <h3>{staffModalMode === "add" ? "Add New Staff Member" : "Edit Staff Member"}</h3>
              <button className="setting1234-modal-close-btn" onClick={closeStaffModal}>
                &times;
              </button>
            </div>

            <form onSubmit={handleStaffSubmit}>
              <div className="setting1234-modal-body">
                <div className="setting1234-form-group">
                  <label>Staff Name *</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter Full Name"
                    value={staffForm.name}
                    onChange={handleStaffFormChange}
                  />
                </div>

                <div className="setting1234-form-group">
                  <label>Role *</label>
                  <select name="role" value={staffForm.role} onChange={handleStaffFormChange}>
                    <option value="">Select Role</option>
                    <option value="Admin">Admin</option>
                    <option value="Data Entry">Data Entry</option>
                    <option value="Field Coordinator">Field Coordinator</option>
                    <option value="PA to MLA">PA to MLA</option>
                    <option value="Social Media Manager">Social Media Manager</option>
                  </select>
                </div>

                <div className="setting1234-form-group">
                  <label>Mobile Number *</label>
                  <input
                    type="tel"
                    name="mobile"
                    placeholder="Enter Mobile Number"
                    maxLength="10"
                    value={staffForm.mobile}
                    onChange={handleStaffFormChange}
                  />
                </div>

                <div className="setting1234-form-group">
                  <label>Status *</label>
                  <select name="status" value={staffForm.status} onChange={handleStaffFormChange}>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>
              </div>

              <div className="setting1234-modal-footer">
                <button type="button" className="setting1234-modal-cancel-btn" onClick={closeStaffModal}>
                  Cancel
                </button>
                <button type="submit" className="setting1234-modal-submit-btn">
                  {staffModalMode === "add" ? "Add Staff" : "Save Changes"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ---------------- DELETE STAFF CONFIRM MODAL ---------------- */}
      {showDeleteModal && (
        <div className="setting1234-modal-overlay" onClick={closeDeleteModal}>
          <div
            className="setting1234-modal-box setting1234-confirm-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="setting1234-confirm-icon">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                <path
                  d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0l-1 14a2 2 0 01-2 2H7a2 2 0 01-2-2L4 6h16z"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <h3 className="setting1234-confirm-title">Remove this staff member?</h3>
            <p className="setting1234-confirm-text">
              This action cannot be undone. Are you sure you want to remove
              this staff member?
            </p>

            <div className="setting1234-confirm-footer">
              <button className="setting1234-modal-cancel-btn" onClick={closeDeleteModal}>
                Cancel
              </button>
              <button className="setting1234-btn-delete" onClick={confirmDeleteStaff}>
                OK, Remove
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ---------------- CHANGE PASSWORD MODAL ---------------- */}
      {showPasswordModal && (
        <div className="setting1234-modal-overlay" onClick={closePasswordModal}>
          <div className="setting1234-modal-box" onClick={(e) => e.stopPropagation()}>
            <div className="setting1234-modal-header">
              <h3>Change Password</h3>
              <button className="setting1234-modal-close-btn" onClick={closePasswordModal}>
                &times;
              </button>
            </div>

            <form onSubmit={handlePasswordSubmit}>
              <div className="setting1234-modal-body">
                <div className="setting1234-form-group">
                  <label>Current Password *</label>
                  <input
                    type="password"
                    name="current"
                    placeholder="Enter current password"
                    value={passwordForm.current}
                    onChange={handlePasswordChange}
                  />
                </div>

                <div className="setting1234-form-group">
                  <label>New Password *</label>
                  <input
                    type="password"
                    name="newPass"
                    placeholder="Enter new password"
                    value={passwordForm.newPass}
                    onChange={handlePasswordChange}
                  />
                </div>

                <div className="setting1234-form-group">
                  <label>Confirm New Password *</label>
                  <input
                    type="password"
                    name="confirm"
                    placeholder="Re-enter new password"
                    value={passwordForm.confirm}
                    onChange={handlePasswordChange}
                  />
                </div>
              </div>

              <div className="setting1234-modal-footer">
                <button type="button" className="setting1234-modal-cancel-btn" onClick={closePasswordModal}>
                  Cancel
                </button>
                <button type="submit" className="setting1234-modal-submit-btn">
                  Update Password
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ---------------- EDIT CONSTITUENCY INFO MODAL ---------------- */}
      {showConstModal && (
        <div className="setting1234-modal-overlay" onClick={closeConstModal}>
          <div className="setting1234-modal-box" onClick={(e) => e.stopPropagation()}>
            <div className="setting1234-modal-header">
              <h3>Edit Constituency Information</h3>
              <button className="setting1234-modal-close-btn" onClick={closeConstModal}>
                &times;
              </button>
            </div>

            <form onSubmit={handleConstSubmit}>
              <div className="setting1234-modal-body">
                <div className="setting1234-form-group">
                  <label>Constituency Name *</label>
                  <input
                    type="text"
                    name="name"
                    value={constForm.name}
                    onChange={handleConstFormChange}
                    required
                  />
                </div>

                <div className="setting1234-form-group">
                  <label>District *</label>
                  <input
                    type="text"
                    name="district"
                    value={constForm.district}
                    onChange={handleConstFormChange}
                    required
                  />
                </div>

                <div className="setting1234-form-group">
                  <label>Total Mandals *</label>
                  <input
                    type="text"
                    name="mandals"
                    value={constForm.mandals}
                    onChange={handleConstFormChange}
                    required
                  />
                </div>

                <div className="setting1234-form-group">
                  <label>Total Villages *</label>
                  <input
                    type="text"
                    name="villages"
                    value={constForm.villages}
                    onChange={handleConstFormChange}
                    required
                  />
                </div>

                <div className="setting1234-form-group">
                  <label>Total Population *</label>
                  <input
                    type="text"
                    name="population"
                    value={constForm.population}
                    onChange={handleConstFormChange}
                    required
                  />
                </div>
              </div>

              <div className="setting1234-modal-footer">
                <button type="button" className="setting1234-modal-cancel-btn" onClick={closeConstModal}>
                  Cancel
                </button>
                <button type="submit" className="setting1234-modal-submit-btn">
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminSettingsPage;